import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Label } from './ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Checkbox } from './ui/checkbox';
import { Alert, AlertDescription } from './ui/alert';
import { Loader2, Plus, Trash2, AlertTriangle, FileText, Upload, X } from 'lucide-react';
import { toast } from 'sonner';
import { stkAPI, filesAPI } from '../lib/api';

const KURUM_TURLERI = [
  { value: 'dernek', label: 'Dernek' },
  { value: 'vakif', label: 'Vakıf' },
  { value: 'kooperatif', label: 'Kooperatif' },
  { value: 'platform', label: 'Platform' },
  { value: 'federasyon', label: 'Federasyon' },
  { value: 'konfederasyon', label: 'Konfederasyon' },
];

const KATKI_ALANLARI = [
  { value: 'egitim', label: 'Eğitim' },
  { value: 'saglik', label: 'Sağlık' },
  { value: 'cevre', label: 'Çevre' },
  { value: 'spor', label: 'Spor' },
  { value: 'kultur', label: 'Kültür' },
  { value: 'sosyal_yardim', label: 'Sosyal Yardım' },
  { value: 'genclik', label: 'Gençlik' },
  { value: 'engelli', label: 'Engelli' },
];

const TABS = [
  { id: 'genel', label: 'Genel Bilgiler' },
  { id: 'iletisim', label: 'İletişim' },
  { id: 'temsilci', label: 'Temsilci' },
  { id: 'yonetim', label: 'Yönetim Kurulu' },
  { id: 'faaliyet', label: 'Faaliyet' },
  { id: 'belgeler', label: 'Belgeler' },
];

const BELGE_TURLERI = [
  { value: 'derbis', label: 'DERBİS Kayıt Belgesi' },
  { value: 'yonetim_kurulu_karari', label: 'Yönetim Kurulu Kararı' },
  { value: 'tuzuk', label: 'Tüzük' },
  { value: 'genel_kurul_tutanagi', label: 'Genel Kurul Tutanağı' },
  { value: 'yetkili_temsilci', label: 'Yetkili Temsilci Belgesi' },
  { value: 'diger', label: 'Diğer' },
];

export const STKEditDialog = ({ open, onClose, application, isOwner, isPrivileged, onSaved, initialTab }) => {
  const [activeTab, setActiveTab] = useState('genel');
  const [loading, setLoading] = useState(false);
  const [uploadingBelge, setUploadingBelge] = useState(false);
  const [selectedBelgeTuru, setSelectedBelgeTuru] = useState('diger');
  const [form, setForm] = useState({});

  useEffect(() => {
    if (application) {
      setForm({
        kurum_adi: application.kurum_adi || '',
        kurum_kisa_adi: application.kurum_kisa_adi || '',
        kurum_turu: application.kurum_turu || '',
        kurulus_tarihi: application.kurulus_tarihi || '',
        sicil_no: application.sicil_no || '',
        vergi_no: application.vergi_no || '',
        adres: application.adres || '',
        telefon: application.telefon || '',
        email: application.email || '',
        web_sitesi: application.web_sitesi || '',
        il_id: application.il_id || '',
        ilce_id: application.ilce_id || '',
        temsilci_adi: application.temsilci_adi || '',
        temsilci_soyadi: application.temsilci_soyadi || '',
        temsilci_tc: application.temsilci_tc || '',
        temsilci_gorevi: application.temsilci_gorevi || '',
        temsilci_telefon: application.temsilci_telefon || '',
        temsilci_email: application.temsilci_email || '',
        yedek_temsilci_adi: application.yedek_temsilci_adi || '',
        yedek_temsilci_soyadi: application.yedek_temsilci_soyadi || '',
        yedek_temsilci_tc: application.yedek_temsilci_tc || '',
        yedek_temsilci_gorevi: application.yedek_temsilci_gorevi || '',
        yedek_temsilci_telefon: application.yedek_temsilci_telefon || '',
        yedek_temsilci_email: application.yedek_temsilci_email || '',
        yonetim_kurulu: application.yonetim_kurulu || [],
        faaliyet_alani: application.faaliyet_alani || '',
        faaliyet_ozeti: application.faaliyet_ozeti || '',
        uye_sayisi: application.uye_sayisi || '',
        aktif_proje_sayisi: application.aktif_proje_sayisi || '',
        katilim_amaci: application.katilim_amaci || '',
        katki_alanlari: application.katki_alanlari || [],
        belgeler: application.belgeler || [],
      });
      setActiveTab(initialTab || 'genel');
    }
  }, [application, initialTab]);

  const setField = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const toggleKatki = (value) => {
    setForm((f) => {
      const list = f.katki_alanlari.includes(value)
        ? f.katki_alanlari.filter((x) => x !== value)
        : [...f.katki_alanlari, value];
      return { ...f, katki_alanlari: list };
    });
  };

  const updateYK = (idx, key, value) => {
    setForm((f) => {
      const yk = [...f.yonetim_kurulu];
      yk[idx] = { ...yk[idx], [key]: value };
      return { ...f, yonetim_kurulu: yk };
    });
  };
  const addYK = () => setForm((f) => ({ ...f, yonetim_kurulu: [...f.yonetim_kurulu, { ad_soyad: '', gorev: '', telefon: '' }] }));
  const removeYK = (idx) => setForm((f) => ({ ...f, yonetim_kurulu: f.yonetim_kurulu.filter((_, i) => i !== idx) }));

  const handleBelgeUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploadingBelge(true);
    try {
      const resp = await filesAPI.upload(file);
      const newBelge = {
        id: resp.data.id,
        name: resp.data.filename || file.name,
        belge_turu: selectedBelgeTuru,
        uploaded_at: new Date().toISOString(),
      };
      setForm((f) => ({ ...f, belgeler: [...f.belgeler, newBelge] }));
      toast.success('Belge eklendi (Kaydet ile başvuruyu güncelleyin)');
    } catch (err) {
      toast.error('Belge yüklenemedi: ' + (err.response?.data?.detail || err.message));
    } finally {
      setUploadingBelge(false);
      e.target.value = '';
    }
  };

  const removeBelge = (idx) => {
    setForm((f) => ({ ...f, belgeler: f.belgeler.filter((_, i) => i !== idx) }));
  };

  const handleSave = async () => {
    if (isOwner && !isPrivileged) {
      if (!window.confirm('Yapacağınız değişiklik sonrasında başvurunuz tekrar inceleme aşamasına alınacaktır. Devam edilsin mi?')) {
        return;
      }
    }
    setLoading(true);
    try {
      const response = await stkAPI.updateApplication(application.id, form);
      toast.success(isOwner && !isPrivileged
        ? 'Başvuru güncellendi ve yeniden incelemeye alındı'
        : 'Başvuru bilgileri güncellendi');
      onSaved(response.data);
      onClose();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Güncelleme başarısız');
    } finally {
      setLoading(false);
    }
  };

  if (!application) return null;

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto" data-testid="stk-edit-dialog">
        <DialogHeader>
          <DialogTitle>STK Başvurusu Düzenle - {application.kurum_adi}</DialogTitle>
        </DialogHeader>

        {isOwner && !isPrivileged && (
          <Alert className="bg-amber-50 border-amber-200">
            <AlertTriangle className="h-4 w-4 text-amber-600" />
            <AlertDescription className="text-amber-800 text-sm">
              Düzenlemenizi kaydettiğinizde başvurunuz <strong>yeniden inceleme</strong> aşamasına alınacaktır.
            </AlertDescription>
          </Alert>
        )}

        {/* Tabs */}
        <div className="flex border-b border-slate-200 -mx-6 px-6 overflow-x-auto">
          {TABS.map((t) => (
            <button
              key={t.id}
              onClick={() => setActiveTab(t.id)}
              className={`px-4 py-2 text-sm font-medium whitespace-nowrap border-b-2 transition-colors ${
                activeTab === t.id ? 'border-blue-600 text-blue-600' : 'border-transparent text-slate-500 hover:text-slate-800'
              }`}
              data-testid={`edit-tab-${t.id}`}
            >
              {t.label}
            </button>
          ))}
        </div>

        {/* Tab içerikleri */}
        <div className="space-y-4 py-2">
          {activeTab === 'genel' && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="col-span-full">
                <Label>Kurum Adı *</Label>
                <Input value={form.kurum_adi} onChange={(e) => setField('kurum_adi', e.target.value)} data-testid="edit-kurum-adi" />
              </div>
              <div>
                <Label>Kısa Adı</Label>
                <Input value={form.kurum_kisa_adi} onChange={(e) => setField('kurum_kisa_adi', e.target.value)} />
              </div>
              <div>
                <Label>Kurum Türü</Label>
                <Select value={form.kurum_turu} onValueChange={(v) => setField('kurum_turu', v)}>
                  <SelectTrigger><SelectValue placeholder="Seçin" /></SelectTrigger>
                  <SelectContent>
                    {KURUM_TURLERI.map((k) => <SelectItem key={k.value} value={k.value}>{k.label}</SelectItem>)}
                  </SelectContent>
                </Select>
              </div>
              <div>
                <Label>Kuruluş Tarihi</Label>
                <Input type="date" value={form.kurulus_tarihi} onChange={(e) => setField('kurulus_tarihi', e.target.value)} />
              </div>
              <div>
                <Label>Sicil No</Label>
                <Input value={form.sicil_no} onChange={(e) => setField('sicil_no', e.target.value)} />
              </div>
              <div>
                <Label>Vergi No</Label>
                <Input value={form.vergi_no} onChange={(e) => setField('vergi_no', e.target.value)} />
              </div>
            </div>
          )}

          {activeTab === 'iletisim' && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="col-span-full">
                <Label>Adres</Label>
                <Textarea value={form.adres} onChange={(e) => setField('adres', e.target.value)} rows={2} />
              </div>
              <div>
                <Label>Telefon</Label>
                <Input value={form.telefon} onChange={(e) => setField('telefon', e.target.value)} />
              </div>
              <div>
                <Label>E-posta</Label>
                <Input type="email" value={form.email} onChange={(e) => setField('email', e.target.value)} />
              </div>
              <div className="col-span-full">
                <Label>Web Sitesi</Label>
                <Input value={form.web_sitesi} onChange={(e) => setField('web_sitesi', e.target.value)} placeholder="https://..." />
              </div>
            </div>
          )}

          {activeTab === 'temsilci' && (
            <div className="space-y-6">
              {/* Asil Temsilci */}
              <div>
                <h4 className="text-sm font-semibold text-slate-800 mb-3 pb-2 border-b border-slate-200">Asıl Temsilci</h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <Label>Adı *</Label>
                    <Input value={form.temsilci_adi} onChange={(e) => setField('temsilci_adi', e.target.value)} />
                  </div>
                  <div>
                    <Label>Soyadı *</Label>
                    <Input value={form.temsilci_soyadi} onChange={(e) => setField('temsilci_soyadi', e.target.value)} />
                  </div>
                  <div>
                    <Label>TC Kimlik *</Label>
                    <Input
                      value={form.temsilci_tc}
                      onChange={(e) => setField('temsilci_tc', e.target.value.replace(/[^0-9]/g, ''))}
                      maxLength={11}
                      placeholder="11 haneli TC No"
                    />
                  </div>
                  <div>
                    <Label>Görevi</Label>
                    <Input value={form.temsilci_gorevi} onChange={(e) => setField('temsilci_gorevi', e.target.value)} />
                  </div>
                  <div>
                    <Label>Telefon</Label>
                    <Input value={form.temsilci_telefon} onChange={(e) => setField('temsilci_telefon', e.target.value)} />
                  </div>
                  <div className="col-span-full">
                    <Label>E-posta</Label>
                    <Input type="email" value={form.temsilci_email} onChange={(e) => setField('temsilci_email', e.target.value)} />
                  </div>
                </div>
              </div>

              {/* Yedek Temsilci */}
              <div>
                <h4 className="text-sm font-semibold text-slate-800 mb-3 pb-2 border-b border-slate-200">
                  Yedek Temsilci <span className="text-xs font-normal text-slate-500 ml-1">(opsiyonel)</span>
                </h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <Label>Adı</Label>
                    <Input value={form.yedek_temsilci_adi} onChange={(e) => setField('yedek_temsilci_adi', e.target.value)} data-testid="yedek-temsilci-adi" />
                  </div>
                  <div>
                    <Label>Soyadı</Label>
                    <Input value={form.yedek_temsilci_soyadi} onChange={(e) => setField('yedek_temsilci_soyadi', e.target.value)} />
                  </div>
                  <div>
                    <Label>TC Kimlik</Label>
                    <Input value={form.yedek_temsilci_tc} onChange={(e) => setField('yedek_temsilci_tc', e.target.value)} maxLength={11} />
                  </div>
                  <div>
                    <Label>Görevi</Label>
                    <Input value={form.yedek_temsilci_gorevi} onChange={(e) => setField('yedek_temsilci_gorevi', e.target.value)} />
                  </div>
                  <div>
                    <Label>Telefon</Label>
                    <Input value={form.yedek_temsilci_telefon} onChange={(e) => setField('yedek_temsilci_telefon', e.target.value)} />
                  </div>
                  <div>
                    <Label>E-posta</Label>
                    <Input type="email" value={form.yedek_temsilci_email} onChange={(e) => setField('yedek_temsilci_email', e.target.value)} />
                  </div>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'yonetim' && (
            <div className="space-y-3">
              {form.yonetim_kurulu.length === 0 && (
                <p className="text-sm text-slate-500">Henüz yönetim kurulu üyesi eklenmemiş.</p>
              )}
              {form.yonetim_kurulu.map((m, idx) => (
                <div key={`yk-${idx}`} className="grid grid-cols-12 gap-2 items-end border border-slate-200 rounded-lg p-3">
                  <div className="col-span-12 md:col-span-4">
                    <Label className="text-xs">Ad Soyad</Label>
                    <Input value={m.ad_soyad || ''} onChange={(e) => updateYK(idx, 'ad_soyad', e.target.value)} />
                  </div>
                  <div className="col-span-12 md:col-span-3">
                    <Label className="text-xs">Görev</Label>
                    <Input value={m.gorev || ''} onChange={(e) => updateYK(idx, 'gorev', e.target.value)} />
                  </div>
                  <div className="col-span-9 md:col-span-4">
                    <Label className="text-xs">Telefon</Label>
                    <Input value={m.telefon || ''} onChange={(e) => updateYK(idx, 'telefon', e.target.value)} />
                  </div>
                  <div className="col-span-3 md:col-span-1">
                    <Button variant="ghost" size="icon" onClick={() => removeYK(idx)} data-testid={`yk-remove-${idx}`}>
                      <Trash2 className="w-4 h-4 text-red-500" />
                    </Button>
                  </div>
                </div>
              ))}
              <Button variant="outline" size="sm" onClick={addYK} data-testid="yk-add-btn">
                <Plus className="w-4 h-4 mr-1" /> Üye Ekle
              </Button>
            </div>
          )}

          {activeTab === 'faaliyet' && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="col-span-full">
                <Label>Faaliyet Alanı</Label>
                <Input value={form.faaliyet_alani} onChange={(e) => setField('faaliyet_alani', e.target.value)} />
              </div>
              <div>
                <Label>Üye Sayısı</Label>
                <Input value={form.uye_sayisi} onChange={(e) => setField('uye_sayisi', e.target.value)} />
              </div>
              <div>
                <Label>Aktif Proje Sayısı</Label>
                <Input value={form.aktif_proje_sayisi} onChange={(e) => setField('aktif_proje_sayisi', e.target.value)} />
              </div>
              <div className="col-span-full">
                <Label>Faaliyet Özeti</Label>
                <Textarea value={form.faaliyet_ozeti} onChange={(e) => setField('faaliyet_ozeti', e.target.value)} rows={3} />
              </div>
              <div className="col-span-full">
                <Label>Katılım Amacı</Label>
                <Textarea value={form.katilim_amaci} onChange={(e) => setField('katilim_amaci', e.target.value)} rows={3} />
              </div>
              <div className="col-span-full">
                <Label className="mb-2 block">Katkı Alanları</Label>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
                  {KATKI_ALANLARI.map((k) => (
                    <label key={k.value} className="flex items-center gap-2 cursor-pointer">
                      <Checkbox
                        checked={form.katki_alanlari.includes(k.value)}
                        onCheckedChange={() => toggleKatki(k.value)}
                        data-testid={`katki-${k.value}`}
                      />
                      <span className="text-sm">{k.label}</span>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          )}

          {activeTab === 'belgeler' && (
            <div className="space-y-4">
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <Label className="text-sm font-medium text-blue-900 mb-2 block">Yeni Belge Yükle</Label>
                <div className="flex flex-col sm:flex-row gap-2">
                  <Select value={selectedBelgeTuru} onValueChange={setSelectedBelgeTuru}>
                    <SelectTrigger className="sm:w-64"><SelectValue /></SelectTrigger>
                    <SelectContent>
                      {BELGE_TURLERI.map((b) => <SelectItem key={b.value} value={b.value}>{b.label}</SelectItem>)}
                    </SelectContent>
                  </Select>
                  <label className="flex-1">
                    <input
                      type="file"
                      onChange={handleBelgeUpload}
                      disabled={uploadingBelge}
                      className="hidden"
                      data-testid="belge-file-input"
                    />
                    <div className={`flex items-center justify-center gap-2 px-4 py-2 border-2 border-dashed border-blue-300 rounded-md cursor-pointer hover:bg-blue-100 transition ${uploadingBelge ? 'opacity-50' : ''}`}>
                      {uploadingBelge ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}
                      <span className="text-sm">{uploadingBelge ? 'Yükleniyor...' : 'Dosya Seç ve Yükle'}</span>
                    </div>
                  </label>
                </div>
                <p className="text-xs text-blue-700 mt-2">PDF, JPG, PNG, DOCX kabul edilir. Maksimum 10 MB.</p>
              </div>

              <div>
                <Label className="text-sm font-medium mb-2 block">Yüklü Belgeler ({form.belgeler?.length || 0})</Label>
                {(!form.belgeler || form.belgeler.length === 0) ? (
                  <p className="text-sm text-slate-500 py-4 text-center bg-slate-50 rounded-md">Henüz belge yüklenmemiş</p>
                ) : (
                  <div className="space-y-2">
                    {form.belgeler.map((belge, idx) => (
                      <div key={`b-${idx}`} className="flex items-center justify-between p-3 border border-slate-200 rounded-lg bg-white">
                        <div className="flex items-center gap-3 min-w-0">
                          <FileText className="w-5 h-5 text-blue-600 flex-shrink-0" />
                          <div className="min-w-0">
                            <p className="text-sm font-medium truncate">{belge.name || `Belge ${idx + 1}`}</p>
                            <p className="text-xs text-slate-500">
                              {BELGE_TURLERI.find((b) => b.value === belge.belge_turu)?.label || belge.belge_turu || 'Belge türü belirtilmedi'}
                            </p>
                          </div>
                        </div>
                        <Button
                          variant="ghost"
                          size="icon"
                          onClick={() => removeBelge(idx)}
                          data-testid={`belge-remove-${idx}`}
                          className="flex-shrink-0"
                        >
                          <X className="w-4 h-4 text-red-500" />
                        </Button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        <DialogFooter className="border-t pt-4">
          <Button variant="outline" onClick={onClose} disabled={loading} data-testid="stk-edit-cancel">
            İptal
          </Button>
          <Button onClick={handleSave} disabled={loading} data-testid="stk-edit-save">
            {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
            Kaydet
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default STKEditDialog;
